import React from 'react';
import {Box, 
        CardMedia,
        makeStyles } from '@material-ui/core/';
import foto from '../Images/DV_nadrz.jpg';
import { useMediaQuery } from 'react-responsive';

import Navbar from './NavbarComponents/NavbarComponent';

const useStyles = makeStyles({
    header: {
        height: '50vh',
        backgroundPosition: '40% 25%',
    },
    phoneHeader: {
        height: '40vh',
        backgroundPosition: '40% 25%',
    },
    shadow: {
        boxShadow: '0px 0px 5px 1px black',
    }
})

function Header() {
    const classes = useStyles();

    const isSmallScreen = useMediaQuery({ query: '(max-width: 850px)' });

    return(
        <Box className={classes.shadow}>
            <CardMedia className={isSmallScreen ? classes.phoneHeader : classes.header} image={foto} >
                <Navbar />
            </CardMedia>
        </Box>
    )
}

export default Header;